import { useEffect, useState } from 'react';

const DEFAULT_DELAY_MS = 300;

/**
 * Returns the value after it has stopped changing for `delay` milliseconds.
 *
 * @param {*} value - The value to debounce
 * @param {number} [delay=300] - Debounce delay in milliseconds
 * @returns {*} The debounced value
 */
export function useDebouncedValue(value, delay = DEFAULT_DELAY_MS) {
	const [debounced, setDebounced] = useState(value);
	useEffect(() => {
		const timer = setTimeout(() => setDebounced(value), delay);
		return () => clearTimeout(timer);
	}, [value, delay]);
	return debounced;
}
